'use strict';
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var arr_1 = require("./arr");
var check_1 = require("./check");
var json_1 = require("./json");
var calc_1 = require("./calc");
var Cast;
(function (Cast) {
    function toArray(iterable) {
        return arr_1.Arr.from(iterable);
    }
    Cast.toArray = toArray;
    function toArrayFromObject(iterable) {
        return Object.values(iterable);
    }
    Cast.toArrayFromObject = toArrayFromObject;
    function toInteger(variable, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        var type = typeof variable;
        if (type === 'number') {
            return toNumericOrElse(Math.floor(variable), defaultValue);
        }
        if (type === 'string') {
            return toNumericOrElse(Number.parseInt(variable, 10), defaultValue);
        }
        if (type === 'boolean') {
            return +variable;
        }
        return defaultValue;
    }
    Cast.toInteger = toInteger;
    function toFinite(value) {
        if (!value) {
            return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY) {
            return (value < 0 ? -1 : 1) * Number.MAX_SAFE_INTEGER;
        }
        return value === value ? value : 0;
    }
    Cast.toFinite = toFinite;
    function toFixed(value, floatPrecision, defaultValue) {
        if (floatPrecision === void 0) { floatPrecision = -1; }
        if (defaultValue === void 0) { defaultValue = 0; }
        if (check_1.Check.isString(value)) {
            if (check_1.Check.isStringNumeric(value)) {
                return calc_1.Calc.toFixed(Cast.toNumber(value), floatPrecision);
            }
            else {
                if (check_1.Check.isNumber(value)) {
                    return calc_1.Calc.toFixed(value, floatPrecision);
                }
                else {
                    return defaultValue;
                }
            }
        }
        else {
            if (check_1.Check.isNumber(value)) {
                return calc_1.Calc.toFixed(value, floatPrecision);
            }
            else {
                return defaultValue;
            }
        }
    }
    Cast.toFixed = toFixed;
    function toMap(value) {
        if (check_1.Check.isPrimitive(value)) {
            return new Map([[undefined, value]]);
        }
        return new Map(Object.entries(value));
    }
    Cast.toMap = toMap;
    function toNumber(variable, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        var type = typeof variable;
        if (type === 'number') {
            return toNumericOrElse(variable, defaultValue);
        }
        if (type === 'string') {
            return toNumericOrElse(Number.parseFloat(variable), defaultValue);
        }
        if (type === 'boolean') {
            return +variable;
        }
        return defaultValue;
    }
    Cast.toNumber = toNumber;
    function toNumericOrElse(value, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        return Number.isNaN(value) || !Number.isFinite(value) ? defaultValue : value;
    }
    Cast.toNumericOrElse = toNumericOrElse;
    function toRealNumber(value) {
        var finite = toFinite(value);
        var remainder = finite % 1;
        return finite === finite ? (remainder ? finite - remainder : finite) : 0;
    }
    Cast.toRealNumber = toRealNumber;
    function toSingle(value, defaultValue, firstElement) {
        if (firstElement === void 0) { firstElement = true; }
        if (!check_1.Check.isObjectLike(value)) {
            return value;
        }
        var index = 0;
        if (Array.isArray(value)) {
            var notSparse = value.filter(function (valueForFilter, index, array) { return index in array; });
            if (notSparse.length === 0) {
                return defaultValue;
            }
            if (firstElement === false) {
                index = notSparse.length - 1;
            }
            return value[index];
        }
        var keys = Object.keys(value);
        if (keys.length === 0) {
            return defaultValue;
        }
        if (firstElement === false) {
            index = keys.length - 1;
        }
        return value[keys[index]];
    }
    Cast.toSingle = toSingle;
    function toString(value) {
        if (typeof value === 'string') {
            return value;
        }
        if (value === null) {
            return '';
        }
        if (check_1.Check.isArray(value)) {
            return arr_1.Arr.map(value, toString) + '';
        }
        var result = value + '';
        return (result === '0' && (1 / value) === -Infinity) ? '-0' : result;
    }
    Cast.toString = toString;
    function toSwitch(cases) {
        if (cases === void 0) { cases = {}; }
        if ((cases instanceof Map) || (cases instanceof WeakMap)) {
            return function (defaultCase) { return function (key) { return cases.has(key) ? cases.get(key) : defaultCase; }; };
        }
        else {
            return function (defaultCase) { return function (key) { return key in cases ? cases[key] : defaultCase; }; };
        }
    }
    Cast.toSwitch = toSwitch;
    function objectToMap(object) {
        var map = new Map();
        try {
            for (var _a = __values(Object.keys(object)), _b = _a.next(); !_b.done; _b = _a.next()) {
                var key = _b.value;
                map.set(key, object[key]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return map;
        var e_1, _c;
    }
    Cast.objectToMap = objectToMap;
    function jsonToMap(json) {
        return objectToMap(json_1.Json.decode(json));
    }
    Cast.jsonToMap = jsonToMap;
    function mapToObject(map) {
        var object = Object.create(null);
        try {
            for (var map_1 = __values(map), map_1_1 = map_1.next(); !map_1_1.done; map_1_1 = map_1.next()) {
                var _a = __read(map_1_1.value, 2), key = _a[0], value = _a[1];
                object[key] = value;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (map_1_1 && !map_1_1.done && (_b = map_1.return)) _b.call(map_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return object;
        var e_2, _b;
    }
    Cast.mapToObject = mapToObject;
    function mapToJson(map) {
        return json_1.Json.encode(mapToObject(map));
    }
    Cast.mapToJson = mapToJson;
    function setToArray(set) {
        return __spread(set);
    }
    Cast.setToArray = setToArray;
    function arrayToSet(array) {
        return new Set(array);
    }
    Cast.arrayToSet = arrayToSet;
})(Cast = exports.Cast || (exports.Cast = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/cast.ts
// module id = 2
// module chunks = 0 1